export const termsOfUse = {
  title: 'Terms of use',
  lastUpdated: '2026-04-23',
  sections: [
    {
      heading: 'About these terms',
      body: [
        'These terms govern the use of the justsee-ltd.com website and the services we provide. By browsing the site or engaging us for work, you agree to them.',
      ],
    },
    {
      heading: 'Services',
      body: [
        'We offer logo design, website design, and website development services. Scope, deliverables, and payment terms are agreed in a separate written proposal for each project before any work begins.',
      ],
    },
    {
      heading: 'Payment',
      body: [
        'Unless otherwise agreed in writing, fifty percent of the project fee is payable on acceptance and the remaining fifty percent before final delivery. Invoices are issued in EUR and payable within fourteen days by bank transfer.',
        'Late payments accrue interest at the statutory rate under Cyprus law.',
      ],
    },
    {
      heading: 'Ownership and intellectual property',
      body: [
        'On receipt of final payment, full copyright and usage rights in the delivered work transfer to you. Until final payment is received, we retain all rights.',
        'We reserve the right to include the delivered work in our portfolio and case studies. If you require confidentiality, tell us in writing before the project starts.',
      ],
    },
    {
      heading: 'Revisions and changes',
      body: [
        'The number of revisions included in each tier is stated in the written proposal. Additional revisions are billed at our standard hourly rate.',
        'Significant changes to scope after sign-off are treated as a change request and re-estimated in writing before work continues.',
      ],
    },
    {
      heading: 'Warranties and liability',
      body: [
        'We warrant that the work is our original creation and that we have the right to deliver it. We do not warrant that the work will meet any particular commercial result.',
        'Our liability under any project is capped at the fees paid under that project. We are not liable for indirect or consequential losses, including loss of profit or data.',
      ],
    },
    {
      heading: 'Termination',
      body: [
        'Either party may terminate a project at any time by written notice. Fees for work already completed remain payable. See our refund policy for details.',
      ],
    },
    {
      heading: 'Governing law',
      body: [
        'These terms and any project agreement are governed by the laws of Cyprus. Any dispute that cannot be settled by negotiation is submitted to the exclusive jurisdiction of the courts of Cyprus.',
      ],
    },
    {
      heading: 'Contact',
      body: [
        'Questions about these terms: business@justsee-ltd.com.',
      ],
    },
  ],
};
